/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum AddToSystemReturnCodes{
    Success = 0,
    BackupFamily = 1,
    NotMetricFamily = 2,
    NotImperialFamily = 3,
    FileNotAvailable = 4,
    InternetConnection = 5,
    AlreadyExist = 6,
    BuildingLayoutTab = 7,
    AccessoriesCustomContentTab = 8,
    AssembliesTab = 9,
    CustomContentTab = 10,
    AccessoriesTab = 11,
    ConduitFieldFabTab = 12,
    LadderCableTrayTab = 13,
    ClearanceFittings = 14,
    ChannelCableTray = 15,
    WireMeshCableTray = 16,
    FamilyNotFound = 17,
    UpdatedFamilies = 18,
    Error = 19,
    WrongTab = 20,
    JunctionBox = 21,
    BuildingLayoutFamily = 22,
}